export const APP_TYPES = {
    FIRE_TV: 'firetv',
    SAMSUNG: 'samsung',
    ROKU: 'roku',
    MOBILE_APP: 'app',
    WEB: 'web',
    SKY: 'sky'
}